/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StopSequenceStructure } from './StopSequenceStructure';

export type VehicleActivityStructure = {
  timetableDelay?: number;
  routeDeviation?: VehicleActivityStructure.routeDeviation;
  journeyMode?: VehicleActivityStructure.journeyMode;
  stopSequence?: Array<StopSequenceStructure>;
  currentStopIndex?: number;
  locationState?: VehicleActivityStructure.locationState;
  nextExitSide?: VehicleActivityStructure.nextExitSide;
};

export namespace VehicleActivityStructure {
  export enum routeDeviation {
    ONROUTE = 'ONROUTE',
    OFFROUTE = 'OFFROUTE',
    UNKNOWN = 'UNKNOWN',
  }

  export enum journeyMode {
    NO_TRIP = 'NO_TRIP',
    ADDITIONAL_TRIP = 'ADDITIONAL_TRIP',
    SERVICE_TRIP = 'SERVICE_TRIP',
  }

  export enum locationState {
    AFTER_STOP = 'AFTER_STOP',
    AT_STOP = 'AT_STOP',
    BEFORE_STOP = 'BEFORE_STOP',
    BETWEEN_STOP = 'BETWEEN_STOP',
  }

  export enum nextExitSide {
    BOTH = 'BOTH',
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    UNKNOWN = 'UNKNOWN',
  }
}
